import { WebRoutes } from '@shared/constants/web-routes.enum';

const publicPaths = new Set<string>([
  WebRoutes.AccountDeletion,
  WebRoutes.AccountDeletionConfirm,
  WebRoutes.AccountDeletionCancel,
  WebRoutes.Support,
  WebRoutes.PrivacyPolicy,
  WebRoutes.TermsOfUse,
  WebRoutes.CookiePolicy,
  '/email/unsubscribe',
]);

export function isPublicWebPath(path: string): boolean {
  return publicPaths.has(path.replace(/\/+$/, '') || '/');
}
